import axios, { AxiosError, AxiosRequestConfig } from 'axios';

import { BASE_URL } from '@/configs';
import AuthService from '@/services/auth.service';
import { ResponseType } from '@/types/common/ResponseErrorType';
import { useStorage } from '@/utils/useStorage';
import router from '@/routers';

const http = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

http.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const storage = useStorage();
    const accessToken = storage.getItem('accessToken');
    config.headers = config.headers ?? {};
    config.headers['X-AUTH-DOMAIN'] = window.location.hostname;
    if (accessToken && config.headers) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

http.interceptors.response.use(
  (response: ResponseType) => {
    if (response.status === 401) {
      AuthService.clearCache();
      return response;
    }

    return {
      status: 200,
      ...response.data,
    };
  },
  (error: AxiosError) => {
    const responseError = error.response;
    switch (error.response?.status) {
      case 401:
        router.push('/candidate/login');
        break;
      default:
        console.log(error.message);
        break;
    }
    return responseError;
  }
);

const request = (url: string, options: AxiosRequestConfig<any>) => {
  return http.request({ ...options, url: url });
};

export { http };
export default request;
